var map = {
	"./findoctor/single-page/home-3": [
		"8b37",
		"chunk-8a573a48"
	],
	"./wedding/single-page/home-3": [
		"d32a",
		"chunk-6d366470"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "57b0";
module.exports = webpackAsyncContext;